import React, { Fragment } from "react";
import { Row, Col, FormGroup, Label } from "reactstrap";

const ServiceItemForm = (props) => {
  const { errors, register } = props;

  return (
    <Fragment>
      <Row>
        <Col>
          <FormGroup>
            <Label className="col-form-label">Service Item Name</Label>
            <input
              name="name"
              type="text"
              {...register("name")}
              className={`form-control ${errors.name ? "is-invalid" : ""}`}
            />
            <div className="invalid-feedback">{errors.name?.message}</div>
          </FormGroup>
        </Col>
      </Row>
    </Fragment>
  );
};

export default ServiceItemForm;
